module.exports = __webpack_public_path__ + "ptc_momoro_F2_2.e48a5cfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_F2_2.jpg
// module id = GdYO
// module chunks = 0